/**
 * Renders VAT (Value Added Tax) line item if applicable.
 * VAT is on everything a company sells, and on nothing a private person sells
 * (P25009-468). Older orders keep the VAT line they were placed with.
 *
 * The VAT amount is displayed as a separate line item with proper formatting.
 *
 * Only the seller gets here now. The buyer's rows are incl. VAT since
 * P25009-475, so OrderBreakdown folds this line into the item rows on the
 * buyer's side and prints "Varav moms" under the total instead
 * (LineItemVatIncludedMaybe).
 *
 * The seller sees the line too since P25009-467 (the VAT line counts for the
 * provider, so it passes OrderBreakdown's role filter). For them it is part of
 * what they are paid — not a fee, not a deduction — and theirs to report to
 * Skatteverket, so it gets its own label. Orders placed before that change have
 * a customer-only VAT line, so the seller simply sees no VAT row there.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_VAT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemVATMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  // Find VAT line item
  const vatLineItem = lineItems.find(item => item.code === LINE_ITEM_VAT && !item.reversal);

  // VAT is shown for both customer and provider
  if (!vatLineItem) {
    return null;
  }

  const formattedTotal = formatMoney(intl, vatLineItem.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        {isProvider ? <FormattedMessage id="OrderBreakdown.vatProvider" /> : 'VAT (Moms)'}
      </span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

LineItemVATMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemVATMaybe;
